<template>
    <div class="col-md-12">
        <div class="h2">Clients</div>

        <div class="row">
            <div class="col-md-12 mb-3">
                <a href="/clients/create" class="btn btn-success float-right d-flex align-items-center"
                   title="Create client">
                    <span class="material-icons-outlined cursor-pointer mr-1">post_add</span> Create client
                </a>
            </div>
        </div>

        <div class="pt-3">
            <data-table
                :url="tableUrl"
                :filters="filters"
                :columns="columns"
                :per-page="perPage"
                :order-by="orderBy"
                :order-dir="orderDir"
                :classes="classes"
                :translate="translate"
                ref="clientTable"
            >
                <div slot="filters" slot-scope="{ tableData, perPage }">
                    <div class="row my-3">
                        <div class="col-md-3">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <button class="btn-sm bg-transparent border-0 d-flex align-items-center">
                                    <span class="material-icons-outlined cursor-pointer">search</span>
                                </button>
                                <input name="name" v-model="tableData.search"
                                       class="form-control form-control border-0 py-0 pl-0 shadow-none form-input"
                                       placeholder="Search"/>
                            </div>
                        </div>
                        <div class="col-md-9 d-flex justify-content-end align-items-center">
                            <div
                                class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <select class="form-control bg-white border-0 py-0 shadow-none "
                                        v-model="filters.length" style="width: 150px;">
                                    <option
                                        :key="index"
                                        :value="records"
                                        v-for="(records, index) in perPage">
                                        {{ records }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <tbody ref="clientTable" slot="body" slot-scope="{ data }" class="table-bordered">
                <tr
                    :key="client.id"
                    v-for="client in data">
                    <td
                        :key="column.name"
                        v-for="column in columns"
                        class="laravel-vue-datatable-td"
                    >
                        <data-table-cell
                            :value="client"
                            :name="column.name"
                            :meta="column.meta"
                            :comp="column.component"
                            :classes="column.classes">
                        </data-table-cell>

                        <slot v-if="column.label === 'Agreements'">
                            <div v-for="agreement in client.agreements" v-if="agreement.deleted_at===null">
                                <a :href="`/agreements/${agreement.id}/edit`"> {{ types[agreement.type] }} </a> <br/>
                            </div>
                        </slot>

                        <slot v-if="column.label === 'Edit'">
                            <a :href="`/clients/${client.id}/edit`" title="Edit Client">
                                <span class="material-icons-outlined cursor-pointer mr-1">edit</span>
                            </a>
                        </slot>

                        <slot v-if="column.label === 'Delete'">
                            <div
                                @click="deleteClient(client.id)">
                                <div
                                    class="material-icons-outlined cursor-pointer text-primary"
                                    title="delete client">delete
                                </div>
                            </div>
                        </slot>

                    </td>
                </tr>
                </tbody>
                <div slot="pagination" slot-scope="{ links, meta }"
                     class="d-flex justify-content-between align-items-center"
                >
                    <div></div>
                    <pagination
                        ref="pagination"
                        :total-pages="meta.last_page"
                        :current-page-prop="meta.current_page"
                        v-if="meta && meta.last_page > 1"
                    ></pagination>
                </div>
            </data-table>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Pagination from "./reusable/Pagination.vue";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";

export default {
    name: "ClientDataTable",
    components: {Pagination},
    mixins: [dataTablePaginationMixin],
    props: {
        url: {type: String, required: true},
        types: {type: Object, required: true},

    },
    data() {
        return {
            tableUrl: this.url,
            perPage: ['10', '25', '50', '100'],
            orderBy: "id",
            orderDir: "desc",
            columns: [
                {
                    label: 'Client',
                    name: 'name',
                    orderable: true,
                },
                {
                    label: 'Agreements',
                    //name: 'agreements',
                    orderable: true,
                },
                {
                    label: 'Bookings last 30 days',
                    name: 'last_30_days_bookings',
                    orderable: true,
                },
                {
                    label: 'Last booking',
                    name: 'last_booking_date',
                    orderable: true,
                },
                {
                    label: 'Billing address',
                    name: 'billing_address',
                    orderable: true,
                },
                {
                    label: 'Primary contact',
                    name: 'primary_contact',
                    orderable: true,
                },
                {
                    label: 'Edit',
                    orderable: false,
                },
                {
                    label: 'Delete',
                    orderable: false,
                },
            ],
            filters: {
                length: 25
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,

                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,
                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                },
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search for ID'
            }
        }
    },
    watch: {
        filters: {
            handler: function(newValue) {
                this.$refs.pagination.changePage('', 1);
            },
            deep: true
        }
    },
    methods: {
        deleteClient(value) {
            if (confirm("Are you sure you want to delete this client?")) {
                axios.delete(`/clients/${value}`).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err))
            }
        },
    }
}
</script>
<style>
th {
    cursor: pointer;
}

.filter-asc, .filter-desc {
    display: none;
}
</style>
